
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <fa-icon *ngIf="isIcon()" [icon]="['fa', link.icon]"></fa-icon>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{
        link.badge.text
      }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]="child"></app-sidebar-nav-item>
      </ng-template>
    </ul>
  